import { AxiosRequestConfig } from 'axios';
import request from './request';

export function getJobFunctions() {
  return request.get('/resources/jobs/job_functions').then(data => ({ job_functions: data }));
}
export function getJobExperiences() {
  return request.get('/resources/jobs/experiences').then(data => ({ experiences: data }));
}
export function getJobCurrencies() {
  return request.get('/resources/jobs/currencies').then(data => ({ currencies: data }));
}
export function getJobSalaries() {
  return request.get('/resources/jobs/salaries').then(data => ({ salaries: data }));
}
export function getJobEmploymentTypes() {
  return request.get('/resources/jobs/employment_types').then(data => ({ employment_types: data }));
}
export function getLanguages() {
  return request.get('/languages_list');
}
export function getLanguagesLevels(config?: AxiosRequestConfig) {
  return request.get('/languages_list/levels', config).then(response => Object.keys(response));
}
export function getCountries() {
  return request.get('/resources/countries');
}
export function getMajors() {
  return request.get('/resources/degrees/major');
}
export function getDegrees() {
  return request.get('/resources/degrees/degree');
}
export function getIndustries() {
  return request.get('/resources/companies/industries');
}
export function getExperiences(config?: AxiosRequestConfig) {
  return request.get('/resources/preferences/experiences', config);
}
export function getPermissions() {
  return request.get('/resources/invites/permissions');
}
export function getBoards({ jobId }, config?: AxiosRequestConfig) {
  return request.get(`/boards?job_id=${jobId}`, config);
}
export function getUniversities(config?: AxiosRequestConfig) {
  return request.get(`/universities/names`, config);
}
export function getWorkPlaces(config?: AxiosRequestConfig) {
  return request.get(`/preferences_countries`, config);
}
